import { apiService } from '../../../shared/services/apiServices';
import { TechnicianPrivileges } from '../types/addTechnicianType';
import technicianEndpoints from './technicianEndpoints';

interface PrivilegeModule {
  key: string;
  name: string;
  permissions?: Array<{ key: string; name: string; allowed: boolean }>;
  fixedPermissions?: Array<{ key: string; name: string; allowed: boolean }>;
}

function transformPrivilegesResponse(
  data: Record<string, PrivilegeModule>
): TechnicianPrivileges {
  const flat: Record<string, boolean> = {};

  Object.values(data).forEach((module) => {
    if (module?.permissions) {
      module.permissions.forEach((perm) => {
        flat[perm.key] = perm.allowed;
      });
    }
  });

  return {
    taskView: flat['taskView'] ?? false,
    taskUpdateStatus: flat['taskUpdateStatus'] ?? false,
    taskFillForm: flat['taskFillForm'] ?? false,
    taskAcceptReject: flat['taskAcceptReject'] ?? false,
    certificateList: flat['certificateList'] ?? false,
    certificateView: flat['certificateView'] ?? false,
    certificateDownload: flat['certificateDownload'] ?? false,
    invoiceList: flat['invoiceList'] ?? false,
    invoiceView: flat['invoiceView'] ?? false,
    invoiceDownload: flat['invoiceDownload'] ?? false,
  };
}

export const getTechnicianPrivilegesApiService = async (
  id: string
): Promise<TechnicianPrivileges | null> => {
  const url = `${technicianEndpoints.TECHNICIANS}/${id}/privileges`;

  try {
    const result = await apiService.getAPI(url);

    if (!result.error) {
      const responseData = result.data as {
        privileges: Record<string, PrivilegeModule>;
      };
      const rawPrivileges = responseData.privileges;
      if (!rawPrivileges) {
        return null;
      }
      return transformPrivilegesResponse(rawPrivileges);
    }

    return null;
  } catch {
    return null;
  }
};
